import React from 'react';

import { get } from 'lodash';

import ExchangeIcon from '../../../assets/icons/exchange-icon';
import { Column } from '../../../modules/table';
import { IExchange } from '../../../services/api/dto/shared';
import { SORT_DIRECTION } from '../../../types';
import { getFormatDate } from '../../../utils/utils';

export type Columns = Column<IExchange>[];

const COLUMNS = (
  onChangeSorting: (direction: SORT_DIRECTION) => void,
  direction: SORT_DIRECTION,
  types: any
): Columns => [
  {
    title: 'Кол-во',
    name: 'tokenCountFrom',
    headerStyle: {
      width: '10%',
    },
    dataGetter: (data) => data.tokenCountFrom,
  },
  {
    title: 'Токен',
    name: 'tokenNameFrom',
    headerStyle: {
      width: '32%',
    },
    dataGetter: (data) =>
      types.find((p: any) => p.code === data.tokenNameFrom)?.name,
    Component: (data) => (
      <div className="flex justify-between" style={{ width: '90%' }}>
        {data.data} <ExchangeIcon />{' '}
      </div>
    ),
  },
  {
    title: 'Кол-во',
    name: 'tokenCountTo',
    headerStyle: {
      width: '10%',
    },
    dataGetter: (data) => data.tokenCountTo,
  },
  {
    title: 'Токен',
    name: 'tokenNameTo',
    headerStyle: {
      width: '32%',
    },
    dataGetter: (data) =>
      types.find((p: any) => p.code === data.tokenNameTo)?.name,
  },
  {
    title: 'Дата и время',
    name: 'createdDate',
    headerStyle: {
      width: '16%',
    },
    isSortable: true,
    direction,
    onChangeSorting: onChangeSorting,
    dataGetter: (data) => getFormatDate(get(data, 'createdDate', new Date())),
  },
];

export default COLUMNS;
